import { listProducts } from '../thunks/marketplace-products';

export const marketplaceProductsReducers = (builder) => {
  builder
    // list products
    .addCase(listProducts.fulfilled, (state, action) => {
      state.products.value = action.payload || [];
      state.products.loading = false;
      state.products.initialised = true;
    })
    .addCase(listProducts.pending, (state) => {
      state.products.loading = true;
      state.products.value = [];
    })
    .addCase(listProducts.rejected, (state) => {
      state.products.loading = false;
      state.products.value = [];
    });
};
